export class ScreenUtil {
  static getScreenWidth() {
    if (typeof window === 'undefined') {
      return 0;
    }

    return window.screen.width / (window.outerWidth / window.innerWidth);
  }

  static getScreenHeight() {
    if (typeof window === 'undefined') {
      return 0;
    }

    return window.screen.height / (window.outerHeight / window.innerHeight);
  }
}
